import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Minibusonretinmumbai() {



    const cardData = {





keyword: "Mini Bus on Rent in Mumbai",

headingDescription: "Shreesha Tours & Travels offers reliable and affordable Mini Bus on Rent in Mumbai for corporate events, employee transportation, family functions, destination weddings, school and college trips, industrial visits, pilgrimage tours, sightseeing, airport transfers, conferences, exhibitions, and outstation group travel across India. Our well-maintained fleet includes 20 Seater, 25 Seater, 27 Seater, 30 Seater, 32 Seater, and luxury Mini Buses equipped with comfortable pushback seats, powerful air conditioning, spacious luggage compartments, music system, charging points, and experienced professional drivers. Whether you are planning a business tour, educational excursion, weekend getaway, wedding transportation, religious journey, or multi-day holiday, our mini bus rental service ensures safe, comfortable, and economical group travel. With transparent pricing, flexible travel itineraries, doorstep pickup anywhere in Mumbai, punctual service, and 24/7 customer support, Shreesha Tours & Travels delivers a hassle-free and enjoyable travel experience for groups of every size.",

topPlaces: [
  {
    title: "Mumbai to Ajanta & Ellora",
    description: "Ajanta and Ellora Caves are UNESCO World Heritage Sites famous for ancient rock-cut caves, Buddhist monasteries, Hindu temples, and remarkable sculptures. Mini buses are ideal for educational tours and large sightseeing groups."
  },
  {
    title: "Mumbai to Omkareshwar",
    description: "Omkareshwar is one of the twelve Jyotirlingas, attracting devotees from across India. Group pilgrimage tours frequently hire mini buses for comfortable long-distance travel."
  },
  {
    title: "Mumbai to Ujjain",
    description: "Ujjain is one of India's holiest cities, renowned for Mahakaleshwar Jyotirlinga, Kal Bhairav Temple, Ram Ghat, and the Kumbh Mela. Mini buses are perfect for religious groups and family pilgrimages."
  },
  {
    title: "Mumbai to Jejuri",
    description: "Jejuri is famous for the Shri Khandoba Temple and its vibrant Bhandara festival. It is a popular pilgrimage destination for devotees traveling in groups."
  },
  {
    title: "Mumbai to Tuljapur",
    description: "Tuljapur is home to the revered Tulja Bhavani Temple, one of Maharashtra's Shakti Peethas. Mini bus rentals provide convenient transportation for religious tours and family groups."
  },
  {
    title: "Mumbai to Nanded",
    description: "Nanded is an important Sikh pilgrimage destination known for Takht Hazur Sahib. It is frequently visited by religious groups and community organizations requiring spacious group transportation."
  },
  {
    title: "Mumbai to Bhuj",
    description: "Bhuj is famous for the Rann of Kutch, White Desert, handicrafts, and cultural heritage. Mini buses are an excellent choice for tourism groups exploring Gujarat."
  },
  {
    title: "Mumbai to Mount Abu",
    description: "Mount Abu is Rajasthan's only hill station, known for Nakki Lake, Dilwara Temples, Guru Shikhar, and scenic viewpoints. Group travelers prefer mini buses for comfortable hill station vacations."
  },
  {
    title: "Mumbai to Dwarka",
    description: "Dwarka is one of the Char Dham pilgrimage sites, famous for the Dwarkadhish Temple, Bet Dwarka, and Gomti Ghat. Mini buses are widely booked for religious tours and senior citizen groups."
  },
  {
    title: "Mumbai to Somnath",
    description: "Somnath is home to the historic Somnath Jyotirlinga Temple located on the Arabian Sea coast. It is one of the most popular pilgrimage destinations for families and large religious groups traveling from Mumbai."
  }
],



"services": [
  {
    "name": "Mini Bus on Rent in Mumbai",
    "description": "Book Mini Bus on Rent in Mumbai for comfortable, safe, and affordable group travel with experienced chauffeurs and well-maintained AC vehicles. Our Mini Bus rental service is ideal for family trips, corporate outings, weddings, school excursions, religious tours, airport transfers, sightseeing, and outstation journeys. Enjoy spacious seating, ample luggage capacity, professional drivers, and flexible one way or round trip packages for a smooth and enjoyable travel experience."
  },
  {
    "name": "Mini Bus Rental Mumbai",
    "description": "Choose Mini Bus Rental Mumbai for reliable transportation with spacious seating, clean interiors, and experienced drivers. Whether you are planning a corporate event, family function, holiday tour, educational trip, or group excursion, our Mini Bus rentals provide comfortable travel with transparent pricing and convenient booking options."
  },
  {
    "name": "Mini Bus Hire Mumbai",
    "description": "Hire Mini Bus Mumbai for safe and hassle-free group transportation with professional chauffeurs and premium AC vehicles. Perfect for weddings, business meetings, conferences, sightseeing tours, religious trips, airport transfers, and long-distance outstation travel with complete travel comfort."
  },
  {
    "name": "Mumbai Mini Bus Service",
    "description": "Book Mumbai Mini Bus Service for dependable group transportation with comfortable seating, modern amenities, and courteous drivers. Our Mini Bus services are suitable for family vacations, corporate travel, employee transportation, school trips, event transportation, and weekend getaways."
  },
  {
    "name": "Mini Bus Booking Mumbai",
    "description": "Complete Mini Bus Booking Mumbai online with instant confirmation, competitive pricing, and flexible travel schedules. Reserve the perfect Mini Bus for your group and enjoy convenient doorstep pickup, experienced chauffeurs, and comfortable travel throughout your journey."
  },
  {
    "name": "Mini Bus with Driver Mumbai",
    "description": "Choose Mini Bus with Driver Mumbai for stress-free travel with trained chauffeurs, spacious AC vehicles, and professional service. Ideal for business travel, weddings, family functions, airport transfers, sightseeing, and interstate travel with complete safety and convenience."
  },
  {
    "name": "Mini Bus Transportation Mumbai",
    "description": "Book Mini Bus Transportation Mumbai for efficient and reliable passenger transport with comfortable seating and experienced drivers. Our service is perfect for office staff transportation, educational institutions, family groups, tourist groups, and event organizers requiring dependable travel solutions."
  },
  {
    "name": "Mini Bus for Group Tour Mumbai",
    "description": "Reserve Mini Bus for Group Tour Mumbai for enjoyable travel with friends, family, schools, colleges, and corporate teams. Enjoy spacious seating, luggage space, professional drivers, and comfortable transportation for sightseeing, holidays, pilgrimage tours, and weekend trips."
  },
  {
    "name": "Mini Bus for Corporate Event Mumbai",
    "description": "Choose Mini Bus for Corporate Event Mumbai for executive transportation, conferences, seminars, exhibitions, office outings, employee transfers, and client events. Our chauffeur-driven Mini Buses ensure punctual, comfortable, and professional travel for every corporate requirement."
  },
  {
    "name": "Mini Bus Airport Transfer Mumbai",
    "description": "Book Mini Bus Airport Transfer Mumbai for timely airport pickup and drop with spacious luggage capacity, flight monitoring, and professional chauffeurs. Ideal for families, tourist groups, corporate teams, and event guests traveling to and from Mumbai Airport."
  },
  {
    "name": "Mini Bus Outstation Rental Mumbai",
    "description": "Hire Mini Bus Outstation Rental Mumbai for one way and round trip travel across Maharashtra, Goa, Gujarat, Karnataka, and other destinations. Enjoy comfortable group travel with experienced drivers, transparent fares, spacious seating, and reliable customer support."
  },
  {
    "name": "Luxury Mini Bus Mumbai",
    "description": "Choose Luxury Mini Bus Mumbai for premium group travel with elegant interiors, reclining seats, air conditioning, entertainment features, and professional chauffeurs. Perfect for VIP transportation, destination weddings, luxury tours, executive travel, and premium family vacations."
  },
  {
    "name": "Affordable Mini Bus Rental Mumbai",
    "description": "Book Affordable Mini Bus Rental Mumbai with budget-friendly pricing, comfortable AC vehicles, and experienced drivers. Travel safely for family functions, school trips, employee transportation, airport transfers, and outstation tours without compromising on comfort or service quality."
  },
  {
    "name": "Best Mini Bus Service Mumbai",
    "description": "Choose the Best Mini Bus Service Mumbai for premium group transportation with well-maintained vehicles, courteous chauffeurs, transparent pricing, and outstanding customer support. Whether you require transportation for weddings, corporate events, airport transfers, sightseeing tours, educational trips, family vacations, or outstation travel, our Mini Bus rental service delivers a safe, comfortable, and memorable travel experience every time."
  }
],
"tableData": [
  ["Mini Bus on Rent in Mumbai", "Mini Bus Rental Mumbai"],
  ["Mini Bus Hire Mumbai", "Mumbai Mini Bus Service"],
  ["Mini Bus Booking Mumbai", "Mini Bus with Driver Mumbai"],
  ["Mini Bus Transportation Mumbai", "Mini Bus for Group Tour Mumbai"],
  ["Mini Bus for Corporate Event Mumbai", "Mini Bus Airport Transfer Mumbai"],
  ["Mini Bus Outstation Rental Mumbai", "Luxury Mini Bus Mumbai"],
  ["Affordable Mini Bus Rental Mumbai", "Best Mini Bus Service Mumbai"]
],




whychoose: [
  {
    WhyChooseheading: "Convenient Mini Bus on Rent in Mumbai",
    WhyChoosedescription: "When your travel plans involve a larger group, Shreesha Travels offers comfortable Mini Bus rental services in Mumbai for corporate events, school trips, family functions, sightseeing tours, weddings, airport transfers, and outstation journeys with professional chauffeur-driven vehicles."
  },
  {
    WhyChooseheading: "Perfect Transportation for Medium & Large Groups",
    WhyChoosedescription: "Our Mini Buses are designed to accommodate groups comfortably, providing spacious seating, generous luggage capacity, and a pleasant travel experience for both short and long-distance trips."
  },
  {
    WhyChooseheading: "Suitable for Every Occasion",
    WhyChoosedescription: "Hire a Mini Bus for employee transportation, educational excursions, religious tours, destination weddings, social gatherings, industrial visits, holiday tours, sporting events, and customized travel requirements."
  },
  {
    WhyChooseheading: "Local & Outstation Mini Bus Services",
    WhyChoosedescription: "Book Mini Buses for travel within Mumbai or to destinations including Pune, Lonavala, Mahabaleshwar, Shirdi, Nashik, Goa, Surat, Ahmedabad, Kolhapur, Bengaluru, and numerous cities across India."
  },
  {
    WhyChooseheading: "Multiple Seating Capacities Available",
    WhyChoosedescription: "We provide Mini Buses in various seating capacities to match your group size, ensuring comfortable travel without the need to book multiple vehicles."
  },
  {
    WhyChooseheading: "Safe & Experienced Professional Drivers",
    WhyChoosedescription: "Our licensed chauffeurs have extensive experience in group transportation and long-distance travel, ensuring punctual arrivals and safe journeys on every route."
  },
  {
    WhyChooseheading: "Comfortable, Clean & Well-Maintained Fleet",
    WhyChoosedescription: "Every Mini Bus is regularly serviced, sanitized, air-conditioned, and inspected to provide passengers with a smooth, reliable, and enjoyable travel experience."
  },
  {
    WhyChooseheading: "Choose Shreesha Travels for Group Transportation",
    WhyChoosedescription: "With flexible booking options, transparent pricing, dedicated customer support, and dependable service, we make Mini Bus rental in Mumbai simple and convenient for every group."
  }
]

};

const faqData = [
  {
    question: "Who should book a Mini Bus on rent in Mumbai?",
    answer: "Mini Buses are ideal for corporate teams, schools, colleges, wedding guests, tour groups, families, religious groups, and event transportation."
  },
  {
    question: "Can I rent a Mini Bus for an outstation trip?",
    answer: "Yes, Mini Buses are available for one-day tours, weekend trips, multi-day vacations, pilgrimages, and long-distance travel across India."
  },
  {
    question: "Do you provide Mini Bus rentals for corporate events?",
    answer: "Yes, companies regularly book our Mini Buses for employee transportation, conferences, seminars, exhibitions, and corporate outings."
  },
  {
    question: "Are airport group transfers available with a Mini Bus?",
    answer: "Yes, we arrange Mini Bus pickups and drops for groups travelling to or from Mumbai Airport with sufficient luggage space."
  },
  {
    question: "Can I book a Mini Bus for weddings and family celebrations?",
    answer: "Yes, Mini Buses are widely used for transporting wedding guests, relatives, and event participants comfortably."
  },
  {
    question: "Do all Mini Bus rentals include a professional driver?",
    answer: "Yes, every Mini Bus booking comes with an experienced chauffeur to ensure safe and hassle-free group travel."
  },
  {
    question: "Can I customize the travel route and schedule?",
    answer: "Yes, personalized itineraries with multiple pickup points, sightseeing stops, overnight stays, and return journeys can be arranged."
  },
  {
    question: "How is the Mini Bus rental fare calculated?",
    answer: "Rental charges are based on the seating capacity, travel distance, trip duration, destination, and your customized travel plan."
  },
  {
    question: "Is advance booking recommended for Mini Bus rentals?",
    answer: "Yes, advance reservations help ensure vehicle availability, especially during holidays, wedding seasons, and weekends."
  },
  {
    question: "How can I book a Mini Bus on Rent in Mumbai with Shreesha Travels?",
    answer: "Provide your travel dates, pickup location, destination, group size, and itinerary to receive a customized quotation and quick booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Desai",
    feedback: "Coordinating transportation for our group became effortless with the spacious Mini Bus. The seating was comfortable, the journey was smooth, and the service remained professional throughout the trip.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Shruti Menon",
    feedback: "Our group tour was managed exceptionally well from start to finish. The Mini Bus offered excellent comfort, plenty of space, and punctual service, making the entire travel experience enjoyable.",
    rating: 5
  }
];











    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mini Bus on Rent in Mumbai",
  "image": "https://www.shreeshatravels.com/assets/images/mini-bus-on-rent-in-mumbai.webp",
  "description":
    "Book Mini Bus on Rent in Mumbai with Shreesha Tours & Travels for safe, comfortable, and reliable group transportation services. We provide well-maintained mini buses with driver available 24x7 for corporate events, school trips, family functions, weddings, sightseeing tours, airport transfers, and outstation group travel.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mini-bus-on-rent-in-mumbai"
  }
};



    return (
        <div>
<Helmet>
  <title>Mini Bus on Rent in Mumbai | Group Transportation | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mini Bus on Rent in Mumbai with Shreesha Travels for reliable group transportation services. Hire mini buses with driver for weddings, corporate events, family trips, school tours, sightseeing, airport transfers, and outstation journeys."
  />

  <meta
    name="keywords"
    content="Mini Bus on Rent in Mumbai, Mini Bus Rental Mumbai, Mini Bus Hire Mumbai, Mumbai Mini Bus Service, Mini Bus Booking Mumbai, Mini Bus with Driver Mumbai, Mini Bus Transportation Mumbai, Mini Bus Rental Service Mumbai, Mumbai Group Travel Bus, Mumbai Corporate Transport Bus, Mumbai Wedding Mini Bus Rental"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/53.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Minibusonretinmumbai;